import angular from 'angular';
import commissionExpectedDetails from './commissionExpectedDetails';
import './style.scss';

export default angular
  .module(
    'commission.scenes.commissionManagement.scenes.commissionLanding.scenes.commissionExpectedDetails',
    [],
  )
  .component('commissionExpectedDetails', commissionExpectedDetails).name;
